import { apiFetch } from './client';
import type { BeAuction } from './auctions';

/** Linha da lista `GET /interests`. */
export interface BeAuctionInterest {
  id: string;
  userId: string;
  auctionId: string;
  createdAt: string;
  updatedAt: string;
  markedForExclusion: boolean;
  markedForExclusionAt: string | null;
  auction: BeAuction;
}

export const interestsApi = {
  list: () => apiFetch<BeAuctionInterest[]>('/interests'),

  add: (auctionId: string) =>
    apiFetch<BeAuctionInterest>(`/interests/${encodeURIComponent(auctionId)}`, {
      method: 'POST',
    }),

  remove: (auctionId: string) => apiFetch<void>(`/interests/${auctionId}`, { method: 'DELETE' }),

  updateExclusion: (auctionId: string, markedForExclusion: boolean) =>
    apiFetch<BeAuctionInterest>(`/interests/${auctionId}/exclusion`, {
      method: 'PATCH',
      body: { markedForExclusion },
    }),
};
